import React, { useEffect, useState } from "react";
import { f7, Page, Icon } from "framework7-react";
import axios from "axios";
import { API_BASE_URL, API_AUTH, IMG_URL } from "./../globals";
const eatBidsLogo = require("./../images/logo/eatbids-logo.png");

const ProfileUpdatePage = () => {
  const [data, setData] = useState({});

  useEffect(() => {
    axios
      .get(API_BASE_URL + "restaurants", {
        headers: {
          Authorization: "Basic " + API_AUTH,
        },
        params: {
          id: localStorage.getItem("id"),
          limits: 1,
          cuisine_type: 0,
        },
      })
      .then((response) => {
        setData(response.data[0]);
        console.log(response.data[0].rest_img);
      })
      .catch((error) => console.log(error));
  }, []);

  function handleLogout() {
    // Clear local storage
    localStorage.clear();

    // Navigate to login page
    f7.views.main.router.navigate("/login/");
  }

  const divStyle = {
    backgroundImage: `url("${eatBidsLogo}")`, // Replace with the actual path to your image
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover", // Adjust as needed (e.g., 'contain', '100% 100%', etc.)
    backgroundPosition: "top left", // Positions the image at the top-left corner
    marginTop: "-30px",
    marginBottom: "-20px",
    marginLeft: "10px",
    width: "106px", // Set the width and height to fill the viewport
    height: "40px",
  };

  return (
    <Page className="bg-white">
      <div className="container container-table">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <header className="section-t-space">
            <div className="container-lg custom-container p-0">
              <div className="header-panel pt-3">
                <h2>Profile</h2>
              </div>
              <div className="custom-logo d-none d-md-block" style={divStyle} />
            </div>
          </header>

          <section className="profile-form mt-3">
            <div className="custom-container p-0">
              <div className="profile-cover">
                {data.rest_img !== null ? (
                  <img
                    className="img-fluid profile-pic"
                    src={
                      data.rest_img !== null ? `${IMG_URL}${data.rest_img}` : ""
                    }
                    alt="profile"
                  />
                ) : (
                  <div className=" no-image-placeholder text-center">
                    <div className="img-fluid profile-pic">
                      <Icon
                        material="photo_camera"
                        size={30}
                        className="mt-4"
                      />
                      {/* <p>Tap to upload image</p> */}
                    </div>
                  </div>
                )}
              </div>
              <div className="profile-name">
                <h5>
                  {data.rest_owner_fname} {data.rest_owner_lname}
                </h5>
                <h6>{data.rest_email}</h6>
              </div>
            </div>
          </section>

          <section>
            <div className="custom-container p-0">
              <ul className="profile-list">
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/profile.svg").default}
                        alt="profile"
                      />
                    </div>
                    <a href="/profileedit/" className="profile-box-name">
                      <h5>Profile</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                      {/* <i className="ri-arrow-right-s-line arrow" /> */}
                    </a>
                  </div>
                </li>
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/setting.svg").default}
                        alt="setting"
                      />
                    </div>
                    <a href="/setting/" className="profile-box-name">
                      <h5>Settings</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                    </a>
                  </div>
                </li>
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src={require("./../img/icon/manage-payment.svg").default} alt="Payment" />                      
                    </div>
                    <a href="/wallet/" className="profile-box-name">
                      <h5>Wallet</h5>
                      <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                    </a>
                  </div>
                </li> */}
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src="#" alt="location" />
                    </div>
                    <a href="manage-delivery-address.html" className="profile-box-name">
                      <h5>Manage Delivery Address</h5>
                      <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                    </a>
                  </div>
                </li> */}
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src="#whishlist.svg" alt="wishlist" />
                    </div>
                    <a href="wishlist.html" className="profile-box-name">
                      <h5>My Wishlist</h5>
                      <i className="ri-arrow-right-s-line arrow" />
                    </a>
                  </div>
                </li> */}
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/my-order.svg").default}
                        alt="My Order"
                      />
                    </div>
                    <a href="/orders/" className="profile-box-name">
                      <h5>Orders</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                    </a>
                  </div>
                </li>
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/my-order.svg").default}
                        alt="My Order"
                      />
                    </div>
                    <a href="/directorders/" className="profile-box-name">
                      <h5>Direct orders</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                    </a>
                  </div>
                </li>{" "}
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/my-order.svg").default}
                        alt="My Order"
                      />
                    </div>
                    <a href="/order_can_list/" className="profile-box-name">
                      <h5>Cancelled orders</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                    </a>
                  </div>
                </li>{" "}
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/my-order.svg").default}
                        alt="My Order"
                      />
                    </div>
                    <a href="/order_exp_list/" className="profile-box-name">
                      <h5>Expired Orders</h5>
                      <Icon
                        ios="material:keyboard_arrow_right"
                        aurora="material:keyboard_arrow_right"
                        md="material:keyboard_arrow_right"
                        className="theme-dark"
                      />
                    </a>
                  </div>
                </li>
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src={require("./../img/icon/logout.svg").default} alt="Logout" />                      
                    </div>
                    <a href="/help/" className="profile-box-name">
                      <h5>Help</h5>
                      <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                    </a>
                  </div>
                </li>
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src={require("./../img/icon/logout.svg").default} alt="Logout" />                      
                    </div>
                    <a href="/restabout/" className="profile-box-name">
                      <h5>About</h5>
                      <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                    </a>
                  </div>
                </li> */}
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src={require("./../img/icon/logout.svg").default} alt="Logout" />                      
                    </div>
                    <a href="voucher.html" className="profile-box-name">
                      <h5>My Voucher</h5>
                      <i className="ri-arrow-right-s-line arrow" />
                    </a>
                  </div>
                </li> */}
                {/* <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img className="img-fluid icon" src={require("./../img/icon/logout.svg").default} alt="Logout" />                      
                    </div>
                    <a href="/notification/" className="profile-box-name">
                      <h5>Notifications</h5>
                      <Icon ios="material:keyboard_arrow_right" aurora="material:keyboard_arrow_right" md="material:keyboard_arrow_right" className='theme-dark'/>
                    </a>
                  </div>
                </li> */}
                <li>
                  <div className="profile-box">
                    <div className="profile-icon">
                      <img
                        className="img-fluid icon"
                        src={require("./../img/icon/logout.svg").default}
                        alt="Logout"
                      />
                    </div>
                    <a
                      href="#"
                      onClick={handleLogout}
                      className="profile-box-name"
                    >
                      <h5>Log Out</h5>
                    </a>
                  </div>
                </li>
              </ul>
            </div>
          </section>
        </div>
      </div>
    </Page>
  );
};

export default ProfileUpdatePage;
